(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function perPage() {
    if (window.matchMedia('(max-width: 749px)').matches) return 2;
    if (window.matchMedia('(max-width: 989px)').matches) return 2;
    return 3;
  }

  function init(root) {
    var viewport = root.querySelector('[data-mm-cg-viewport]');
    var track = root.querySelector('[data-mm-cg-track]');
    var prev = root.querySelector('[data-mm-cg-prev]');
    var next = root.querySelector('[data-mm-cg-next]');
    var dotsWrap = root.querySelector('[data-mm-cg-dots]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('[data-mm-cg-slide]');
    var page = 0;

    function pageCount() {
      var n = perPage();
      return Math.max(1, Math.ceil(slides.length / n));
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = pageCount();
      if (isMobile() || pages <= 1) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm-catgrid__dot' + (i === page ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.addEventListener('click', function (idx) {
          return function () {
            page = idx;
            update();
          };
        }(i));
        dotsWrap.appendChild(btn);
      }
    }

    function update() {
      if (isMobile()) {
        track.style.transform = '';
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        if (dotsWrap) dotsWrap.hidden = true;
        return;
      }

      var n = perPage();
      var pages = pageCount();
      if (page > pages - 1) page = pages - 1;
      if (page < 0) page = 0;

      var slide = slides[0];
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(track).gap || 0) || 0;
      var slideW = slide.getBoundingClientRect().width + gap;
      var offset = page * n * slideW;
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

      if (prev) {
        prev.style.display = '';
        prev.disabled = page <= 0;
      }
      if (next) {
        next.style.display = '';
        next.disabled = page >= pages - 1;
      }
      renderDots();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        page -= 1;
        update();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        page += 1;
        update();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 120);
    });

    update();
  }

  function boot() {
    document.querySelectorAll('[data-mm-catgrid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mm-catgrid]');
    if (root) init(root);
  });
})();
